/**
 * Product Carousel
 * Handles horizontal scrolling carousel with arrow navigation
 */

class ProductCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-carousel-track]');
    this.slides = Array.from(this.track.children);
    this.prevButton = section.querySelector('.product-carousel__arrow--prev');
    this.nextButton = section.querySelector('.product-carousel__arrow--next');
    
    this.currentIndex = 0;
    this.slidesToScroll = 1;
    
    if (!this.track || this.slides.length === 0) return;
    
    this.init();
  }

  init() {
    this.updateButtonStates();
    this.attachEventListeners();
    this.handleResize();
    
    window.addEventListener('resize', () => this.handleResize());
  }

  attachEventListeners() {
    this.prevButton?.addEventListener('click', () => this.scrollPrev());
    this.nextButton?.addEventListener('click', () => this.scrollNext());
    
    // Touch/swipe support
    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });

    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    });

    this.track.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      
      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          this.scrollNext();
        } else {
          this.scrollPrev();
        }
      }
    });
  }

  handleResize() {
    this.updateButtonStates();
  }

  scrollPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex -= this.slidesToScroll;
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.updateCarousel();
    }
  }

  scrollNext() {
    const maxIndex = this.getMaxIndex();
    if (this.currentIndex < maxIndex) {
      this.currentIndex += this.slidesToScroll;
      if (this.currentIndex > maxIndex) this.currentIndex = maxIndex;
      this.updateCarousel();
    }
  }

  getMaxIndex() {
    const slidesPerView = this.getSlidesPerView();
    return Math.max(0, this.slides.length - slidesPerView);
  }

  getSlidesPerView() {
    const width = window.innerWidth;
    if (width <= 480) return 1;
    if (width <= 749) return 2;
    if (width <= 1024) return 3;
    if (width <= 1200) return 4;
    return 5;
  }

  updateCarousel() {
    const slideWidth = this.slides[0].offsetWidth;
    const gap = 16;
    const offset = -(this.currentIndex * (slideWidth + gap));
    
    this.track.style.transform = `translateX(${offset}px)`;
    this.updateButtonStates();
  }

  updateButtonStates() {
    const maxIndex = this.getMaxIndex();
    
    if (this.prevButton) {
      this.prevButton.disabled = this.currentIndex === 0;
    }
    
    if (this.nextButton) {
      this.nextButton.disabled = this.currentIndex >= maxIndex;
    }
  }
}

// Initialize all carousels on the page
function initCarousels() {
  const carouselSections = document.querySelectorAll('.product-carousel-section');
  carouselSections.forEach(section => {
    new ProductCarousel(section);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarousels);
} else {
  initCarousels();
}

// Re-initialize on Shopify section updates
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.product-carousel-section');
  if (section) {
    new ProductCarousel(section);
  }
});
